import * as isNode from 'detect-node';
var isServerSide = isNode;
export var thisIsServer = function thisIsServer() {
  return isServerSide = true;
};
export var isThisServer = function isThisServer() {
  return isServerSide;
};